/*
 * Copyright (c) 2021.  Sanish Manandhar
 * All Rights Reserved
 */

export const TAX_RETURN_FETCH_REQUEST = 'TAX_RETURN_FETCH_REQUEST';
export const TAX_RETURN_FETCH_REQUEST_SUCCESS = 'TAX_RETURN_FETCH_REQUEST_SUCCESS';
export const TAX_RETURN_FETCH_REQUEST_FAILURE = 'TAX_RETURN_FETCH_REQUEST_FAILURE';
